import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { AcountingHeading } from '../common/AcountingHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import * as id from '../common/AcountingId'
import * as lb from '../common/AcountingLables'
import Datepicker from '../../../common/datePicker'
import moment from 'moment'
import { busAndCargoOpt, generateMemo } from '../common/AcountingConstants'
import BusMemo from './BusMemo'
import CargoMemo from './CargoMemo'
import BusAndCargoMemoTable from './BusAndCargoMemoTable'
import { connect } from 'react-redux'
import { focusElemnt, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { updateLoader, updateAlertError } from '../../../../store/common/common_action'
import { getVehicleNoData, getBusMemoData, getBusMemoPrintData, getCargoMemoData, CargoMemoVoucherUpdate, getCargoMemoPrintData } from '../../../../store/Acounting/acounting_action'
const BusAndCargoMemo = (props) => {
  const {
    data: { common },
    updateLoader,
    getVehicleNoData,
    updateAlertError,
    getBusMemoPrintData,
    getBusMemoData,
    getCargoMemoData,
    CargoMemoVoucherUpdate,
    getCargoMemoPrintData
  } = props
  const { loginData } = common
  let reportName = 'Bus And Cargo Memo'
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [selGenerateMemo, setSelGenerateMemo] = useState(generateMemo[0])
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [selVehicle, setSelVehicle] = useState('')
  const [vehicleOpt, setVehicleOpt] = useState([])
  const [selInclGSTComm, setSelInclGSTComm] = useState(busAndCargoOpt[0])
  const [selOfflineBooking, setSelOfflineBooking] = useState(busAndCargoOpt[0])
  const [selToPayHamali, setSelToPayHamali] = useState(busAndCargoOpt[0])
  const [reportData, setReportData] = useState([])

  const getVehicleData = () => {
    setShowTable(false)
    setIsPdfLoading(false)
    setReportData([])
    if (selGenerateMemo === '' || selGenerateMemo === ' ') {
      updateAlertError({ show: true, msg: 'Please select Generate Memo', nextId: 'goBtn' })
    } else {
      const body = {
        intCompanyID: loginData?.intCompanyID,
        intFromCityID: loginData?.intBranchCityID,
        intToCityID: loginData?.intBranchID,
        dtJdate: moment(fromDate).format('YYYY-MM-DD'),
        intMode: selGenerateMemo?.id,
        intFromBranchID: loginData?.intBranchID,
      }
      getVehicleNoData(body).then((res) => {
        updateLoader(false)
        if (res.status === 'Success') {
          setVehicleOpt(res.Data)
          setSelVehicle(res.Data?.[0] || ' ')
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'goBtn' })
          setVehicleOpt([])
          setSelVehicle(' ')
        }
      }).catch((err) => {
        console.log("Error:", err)
        setVehicleOpt([])
        setSelVehicle(' ')
      })
    }

  }

  const getBusMemoReportData = () => {
    setShowTable(false)
    if (selVehicle === '' || selVehicle === ' ') {
      updateAlertError({ show: true, msg: 'Please select Vehicle No', nextId: 'loadbtn' })
    } else {
      const body = {
        intCompanyID: loginData?.intCompanyID,
        intFromCityID: loginData?.intBranchCityID,
        dtJdate: moment(fromDate).format('YYYY-MM-DD'),
        BusMasterId: selVehicle?.VehicleID
      }
      getBusMemoData(body).then((res) => {
        updateLoader(false)
        if (res.status === 'Success') {
          setReportData(res?.Data?.Table || [])
          setShowTable(true)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'loadbtn' })
          setShowTable(false)
        }
      })
    }
  }

  const getCargoMemoReportData = () => {
    setShowTable(false)
    setIsPdfLoading(false)
    if (selVehicle === '' || selVehicle === ' ') {
      updateAlertError({ show: true, msg: 'Please select Vehicle No', nextId: 'loadbtn' })
    } else if (selInclGSTComm === '' || selInclGSTComm === ' ') {
      updateAlertError({ show: true, msg: 'Please select Incl. GST on Comm', nextId: 'Incl_GST_Comm' })
    } else if (selOfflineBooking === '' || selOfflineBooking === ' ') {
      updateAlertError({ show: true, msg: 'Please select Offline Booking', nextId: 'Offline_Booking' })
    } else if (selToPayHamali === '' || selToPayHamali === ' ') {
      updateAlertError({ show: true, msg: 'Please select To Pay Hamali', nextId: 'To_Pay_Hamali' })
    } else {
      const body = {
        intCompanyID: loginData?.intCompanyID,
        strVehicleNo: selVehicle?.VehicleWithDetail,
        dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(fromDate).format('YYYY-MM-DD'),
        intFromCityID: loginData?.intBranchCityID,
        intToCityID: 0,
        intUserID: loginData?.intUserID,
        intBranchID: loginData?.intBranchID,
        intIncludeGSTonComm: selInclGSTComm?.id,
        intVehicleID: selVehicle?.VehicleID,
        intHasOfflineVehicle: selOfflineBooking?.id,
        RemoveTopayHamali: selToPayHamali?.id,
      }
      getCargoMemoData(body).then((res) => {
        updateLoader(false)
        if (res.status === 'Success') {
          setReportData(res?.Data?.Table1 || [])
          setShowTable(true)
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'loadbtn' })
          setShowTable(false)
        }
      })
    }

  }

  const resetAllValue = () => {
    setSelVehicle(' ')
    setVehicleOpt([])
    setShowTable(false)
    setReportData([])
    setIsPdfLoading(false)
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <AcountingHeading reportName={reportName} />
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', paddingTop: '16px !important' }}>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              name={'Select_Dispatch_Date'}
              label={`Select Dispatch Date`}
              value={fromDate}
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id?.generateMemo)
                if (moment(date).format('YYYY-MM-DD') !== moment(fromDate).format('YYYY-MM-DD')) {
                  resetAllValue()
                }
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.generateMemo}
              label={lb.generateMemo}
              data={generateMemo || []}
              value={selGenerateMemo?.name || selGenerateMemo}
              defaultvalue={selGenerateMemo?.name || selGenerateMemo}
              onSelect={(val) => {
                setSelGenerateMemo(val)
                if (selVehicle !== '' && selVehicle !== " ") {
                  resetAllValue()
                }
              }}
              onReset={() => {
                setSelGenerateMemo('')
                if (selVehicle !== '' && selVehicle !== " ") {
                  resetAllValue()
                }
              }}
              dataKey={`name`}
              idKey={`uniqueId`}
              width="100%"
              nextId={'goBtn'}
              prevId={id?.fromDate}
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" id="goBtn" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
              onKeyDown={(e) => {
                navigation3(e, id.selectVehicle, id.generateMemo, () => { })
              }}
              onClick={() => {
                getVehicleData()
              }}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectVehicle}
              label={lb.selectVehicle}
              data={removeDuplicatesFromArray(vehicleOpt, 'VehicleID') || []}
              value={selVehicle?.VehicleWithDetail || selVehicle}
              defaultvalue={selVehicle?.VehicleWithDetail || selVehicle}
              width="100%"
              dataKey={`VehicleWithDetail`}
              idKey={`VehicleID`}
              onSelect={(val) => {
                setSelVehicle(val)
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)
              }}
              onReset={() => {
                setSelVehicle('')
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)
              }}
              nextId={selGenerateMemo?.id === 601 ? 'loadbtn' : id.inclGSTComm}
              prevId={'goBtn'}
            />
          </Item>

          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.inclGSTComm}
              label={lb.inclGSTComm}
              data={busAndCargoOpt || []}
              value={selInclGSTComm?.name || selInclGSTComm}
              defaultvalue={selInclGSTComm?.name || selInclGSTComm}
              onSelect={(val) => {
                setSelInclGSTComm(val)
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)

              }}
              onReset={() => {
                setSelInclGSTComm('')
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)

              }}
              dataKey={`name`}
              idKey={`id`}
              disabled={selGenerateMemo?.id === 601}
              width="100%"
              nextId={id.offlineBooking}
              prevId={id.generateMemo}
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.offlineBooking}
              label={lb.offlineBooking}
              data={busAndCargoOpt || []}
              value={selOfflineBooking?.name || selOfflineBooking}
              defaultvalue={selOfflineBooking?.name || selOfflineBooking}
              onSelect={(val) => {
                setSelOfflineBooking(val)
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)

              }}
              onReset={() => {
                setSelOfflineBooking('')
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)

              }}
              dataKey={`name`}
              idKey={`id`}
              disabled={selGenerateMemo?.id === 601}
              width="100%"
              nextId={id.toPayHamali}
              prevId={id.inclGSTComm}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.toPayHamali}
              label={lb.toPayHamali}
              data={busAndCargoOpt || []}
              value={selToPayHamali?.name || selToPayHamali}
              defaultvalue={selToPayHamali?.name || selToPayHamali}
              onSelect={(val) => {
                setSelToPayHamali(val)
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)

              }}
              onReset={() => {
                setSelToPayHamali('')
                setShowTable(false)
                setReportData([])
                setIsPdfLoading(false)
              }}
              dataKey={`name`}
              idKey={`id`}
              disabled={selGenerateMemo?.id === 601}
              width="100%"
              nextId={'loadbtn'}
              prevId={id.offlineBooking}
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" id='loadbtn' style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
              onKeyDown={(e) => {
                navigation3(e, isPdfLoading ? 'backBtn' : selGenerateMemo?.id === 601 ? `Print-0` : `Edit-0`, selGenerateMemo?.id === 601 ? id?.generateMemo : id.toPayHamali, () => { })
              }}
              onClick={() => {
                if (selGenerateMemo?.uniqueId === 1) {
                  getBusMemoReportData()
                } else if (selGenerateMemo?.uniqueId === 2 || selGenerateMemo?.uniqueId === 3) {
                  getCargoMemoReportData()
                }
              }}
            >
              LOAD
            </Button>
          </Item>
        </Box>

        {showTable ? selGenerateMemo?.uniqueId === 601 ? <BusMemo fromDate={fromDate} selVehicle={selVehicle} reportData={reportData} getBusMemoPrintData={getBusMemoPrintData} updateAlertError={updateAlertError} loginData={loginData} isPdfLoading={isPdfLoading} setIsPdfLoading={setIsPdfLoading} /> : selGenerateMemo?.uniqueId === 2 ? <CargoMemo fromDate={fromDate} selVehicle={selVehicle} selInclGSTComm={selInclGSTComm} selOfflineBooking={selOfflineBooking} selToPayHamali={selToPayHamali} getCargoMemoPrintData={getCargoMemoPrintData} updateAlertError={updateAlertError} getCargoMemoReportData={getCargoMemoReportData} reportData={reportData} loginData={loginData} isPdfLoading={isPdfLoading} setIsPdfLoading={setIsPdfLoading} CargoMemoVoucherUpdate={CargoMemoVoucherUpdate} /> : selGenerateMemo?.uniqueId === 3 ? <BusAndCargoMemoTable fromDate={fromDate} selVehicle={selVehicle} selInclGSTComm={selInclGSTComm} selOfflineBooking={selOfflineBooking} selToPayHamali={selToPayHamali} getBusMemoPrintData={getBusMemoPrintData} updateAlertError={updateAlertError} getCargoMemoReportData={getCargoMemoReportData} reportData={reportData} loginData={loginData} isPdfLoading={isPdfLoading} setIsPdfLoading={setIsPdfLoading} CargoMemoVoucherUpdate={CargoMemoVoucherUpdate} getCargoMemoPrintData={getCargoMemoPrintData} /> : null : null}

      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateLoader, getVehicleNoData, updateAlertError, getBusMemoPrintData, getBusMemoData, getCargoMemoData, CargoMemoVoucherUpdate, getCargoMemoPrintData }

export default connect(mapStateToProps, mapDispatchToProps)(BusAndCargoMemo)